<template>
  <div class="my-profile">
    <Nav />
    <span class="overlay" :class="{active: isMenuOpen || isUpdateProfileModalOpen}"></span>
    <div class="header header-standard">
      <HeaderNavBar back route="MyProfile" />
    </div>
    <div class="header-image grey"></div>

    <div class="content-wrap content-wrap-alt content-wrap-nav">
      <SectionTitle
        icon="OutOfOfficeIcon"
        subtitle="My Profile"
        title="Out of Office Hours"
        colour="profile profile-green"
      />

      <form class="form-style" @submit.prevent>
        <section class="ooo-section">
          <b-field label="Out of Office Requests"></b-field>

          <b-table class="ooo-table" :data="outOfOfficesLocal" :striped="true" :sortable="false" :mobile-cards="true" narrow>
            <b-table-column field="start_date" label="Start Date">
              <template #default="props">
                {{ props.row.start_date | moment('LL') }}
              </template>
            </b-table-column>

            <b-table-column field="end_date" label="End Date">
              <template #default="props">
                {{ props.row.end_date | moment('LL') }}
              </template>
            </b-table-column>

            <b-table-column field="reason" label="Reason">
              <template #default="props">
                {{ props.row.reason }}
              </template>
            </b-table-column>

            <b-table-column field="status" label="Status">
              <template #default="props">
                {{ props.row.status }}
              </template>
            </b-table-column>

            <b-table-column label="">
              <template #default="props">
                <CloseIcon class="ooo-close-icon" style="width: 19px;" @click="removeOOO(props.row.id)" />
              </template>
            </b-table-column>
          </b-table>

          <b-button class="ooo-add-button" size="is-small" type="is-info" @click="showAddOOO = !showAddOOO">
            {{ showAddOOO ? 'Cancel' : 'Add New OOO' }}
          </b-button>

          <div v-if="showAddOOO" class="ooo-add-form">
            <b-field class="with-sub field-date" label="Start Date">
              <b-datepicker
                v-model="form.start_date"
                trap-focus
                placeholder="DD/MM/YYYY"
                icon-right="calendar-day"
                :mobile-native="true"
              >
              </b-datepicker>
            </b-field>
            <b-field class="with-sub field-date" label="End Date">
              <b-datepicker
                v-model="form.end_date"
                trap-focus
                placeholder="DD/MM/YYYY"
                icon-right="calendar-day"
                :mobile-native="true"
                :min-date="new Date(form.start_date)"
              >
              </b-datepicker>
            </b-field>
            <b-field label="Reason">
              <b-input v-model="form.reason" required />
            </b-field>
            <Button icon="ArrowRightIcon" @click.native="submitOOO" text="Submit" class="btn btn-green btn-med btn-tick btn-square btn-icon btn-icon-right"></Button>
          </div>
        </section>
      </form>
    </div>

    <UpdateProfileOverlay />
    <Menu />
  </div>
</template>

<script>
import Nav from '@/components/Nav.vue';
import HeaderNavBar from '@/components/HeaderNavBar.vue';
import Menu from '@/components/Menu.vue';
import SectionTitle from '@/components/SectionTitle.vue';
import UpdateProfileOverlay from '@/components/UpdateProfileOverlay.vue';
import PortAdminService from '@/services/PortAdminService';
import CloseIcon from '@/assets/close-grey.svg';
import Button from '@/components/Button.vue';
import axios from 'axios';

export default {
  name: 'MyProfileOutOfOffice',
  components: {
    Nav,
    HeaderNavBar,
    Menu,
    SectionTitle,
    UpdateProfileOverlay,
    CloseIcon,
    Button
  },
  data () {
    // Create JavaScript Date objects for the datepicker
    const today = new Date();
    const weekLater = new Date();
    weekLater.setDate(today.getDate() + 7);
    
    // Store example data with string dates for display in the table
    const todayStr = today.toISOString().substr(0, 10);
    const weekLaterStr = weekLater.toISOString().substr(0, 10);
    
    return {
      showAddOOO: false, 
      outOfOfficesLocal: [], 
      form: {
        start_date: today, // Use Date objects for datepicker
        end_date: weekLater, 
        reason: ''
      }
    };
  },
  watch: {
    'form.start_date' (newVal) {
      if (newVal) {
        // Make sure we have a valid Date object
        const d = new Date(newVal);
        d.setDate(d.getDate() + 7);
        this.form.end_date = d;
      }
    }
  },
  computed: {
    isMenuOpen () {
      return this.$store.state.isMenuOpen;
    },
    isUpdateProfileModalOpen () {
      return this.$store.state.isUpdateProfileModalOpen;
    }
  },
  methods: {
    async submitOOO () {
      if (!this.form.start_date || !this.form.end_date || !this.form.reason) {
        alert('Please fill in all fields');
        return;
      }

      const payload = {
        start_date: this.form.start_date instanceof Date 
          ? this.form.start_date.toISOString().substr(0, 10) 
          : this.form.start_date,
        end_date: this.form.end_date instanceof Date 
          ? this.form.end_date.toISOString().substr(0, 10) 
          : this.form.end_date,
        reason: this.form.reason
      };
      
      try {
        await PortAdminService.addPortAdminOOO(payload);
        this.form.reason = '';
        const today = new Date();
        const weekLater = new Date();
        weekLater.setDate(today.getDate() + 7);
        this.form.start_date = today;
        this.form.end_date = weekLater;
        this.showAddOOO = false;
        await this.fetchOOOData();
      } catch (error) {
        console.error(error);
        alert('Error adding Out of Office request');
      }
    },
    removeOOO (id) {
      if (confirm('Are you sure you want to delete this record?')) {
        PortAdminService.deletePortAdminOOO(id).then(() => {
          this.outOfOfficesLocal = this.outOfOfficesLocal.filter(o => o.id !== id);
        }).catch(() => {
          alert('Error deleting record');
        });
      }
    },
    fetchOOOData () {
      PortAdminService.getPortAdminOOO().then(res => {
        // Process data from API (would typically be string dates)
        this.outOfOfficesLocal = res.data;
        
        // Reset form with Date objects
        const today = new Date();
        const weekLater = new Date();
        weekLater.setDate(today.getDate() + 7);
        
        this.form.start_date = today;
        this.form.end_date = weekLater;
        this.form.reason = '';
        this.showAddOOO = false;
      });
    }
  },
  mounted () {
    this.fetchOOOData();
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.form-style {
  margin-top: 30px;
  margin-bottom: 30px;
}

.ooo-close-icon {
  display: block;
  cursor: pointer;
  g {
    stroke: $red_base;
  }
}

.ooo-section {
  padding: 10px 0;
}

.ooo-add-button {
  margin-top: 20px;
  background: $green_base;
  font-size: 14px;
  &:hover {
    background: $green_base;
  }
}

.control {
  margin-right: 10px;
  min-width: 160px;
}

.ooo-add-form {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 12px;
  margin-top: 12px;
}
</style>

<style lang="scss">
.ooo-table {
  position: relative;
  .table {
    width: 100%;
    td, th {
      font-size: 14px;
      line-height: 20px;
      text-align: left;
    }
  }
}
</style>
